import { FaceDirection, SegmentListItem } from 'domain/types/building/Facade';
import { Face } from 'domain/types/building/Face';
import { FloorType } from 'domain/types/building/Floor';

export enum PvActivationState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  MIXED = 'mixed',
}

export interface SelectedRoofSegmentProperties {
  roofPvPercentages: number[];
}

export type MonthlyNumberValues = [
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
];

export interface SolarLimits {
  yearlyReduction: [number, number];
  yearlyIrradiation: [number, number];
  reductionMonthlyMin: MonthlyNumberValues;
  reductionMonthlyMax: MonthlyNumberValues;
  irradiationMonthlyMin: MonthlyNumberValues;
  irradiationMonthlyMax: MonthlyNumberValues;
}

export type SolarSegments = Record<string, SolarSegment>;

export interface SolarSegment {
  yearlyIrradiation: number;
  yearlyIrradiationReduction: number;
  monthlyIrradiation: MonthlyNumberValues;
  monthlyIrradiationReduction: MonthlyNumberValues;
}

export interface BuildingPvFloorWalls extends SegmentListItem {
  floors: PvFloorWallVariants[];
}

export interface BuildingPvWall extends SegmentListItem {
  id: string;
  direction: number;
  directionName: FaceDirection;
  segmentsWithActivePv: SegmentListItem;
  segmentsWithInactivePv: SegmentListItem;
  segmentsWithNoPv: SegmentListItem;
}

export interface BuildingPvWallVariants extends SegmentListItem {
  walls: BuildingPvWall[];
}

export interface PvFloorVariants extends SegmentListItem {
  floorId: string;
  segmentsWithActivePv: SegmentListItem;
  segmentsWithInactivePv: SegmentListItem;
  segmentsWithNoPv: SegmentListItem;
}

export interface PvFloorWallVariants extends SegmentListItem {
  floorId: string;
  floorNumber: number;
  floorType: FloorType;
  faces: PvFaceVariant[];
}

export interface PvFaceVariant extends SegmentListItem {
  direction: number;
  directionName: FaceDirection;
  face: Face;
  segmentsWithActivePv: SegmentListItem;
  segmentsWithInactivePv: SegmentListItem;
  segmentsWithNoPv: SegmentListItem;
}

export interface BuildingPvFloors extends SegmentListItem {
  floors: PvFloorVariants[];
}

export interface BuildingPvVariants {
  totalSegmentCount: number;
  selectedSegmentCount: number;
  segmentIds: string[];
  segmentsWithActivePv: SegmentListItem;
  segmentsWithInactivePv: SegmentListItem;
  segmentsWithNoPv: SegmentListItem;
}

export interface RoofSegmentPvVariants extends SegmentListItem {
  segmentPvVariants: Record<number, SegmentListItem>;
}

export interface RoofFacePvVariants extends SegmentListItem {
  faceId: string;
  segmentPvVariants: RoofSegmentPvVariants;
}

export enum SolarExposureType {
  IRRADIATION = 'irradiation',
  SHADING_FACTOR = 'shadingFactor',
}

export enum SolarExposureInterval {
  YEAR = 'year',
  MONTH = 'month',
}

export interface PvSegment {
  power: number;
  pvArea: number;
  pvEfficiency: number;
}

export type PvSegments = Record<string, PvSegment>;
